import { render, staticRenderFns } from "./landXian.vue?vue&type=template&id=5bc369ca&scoped=true"
import script from "./landXian.vue?vue&type=script&lang=js"
export * from "./landXian.vue?vue&type=script&lang=js"
import style0 from "./landXian.vue?vue&type=style&index=0&id=5bc369ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc369ca",
  null
  
)

export default component.exports